(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["iframe-video"]) return;
  try {
    
	const postervideo = document.querySelector('[id^="Deferred-Poster-"]');
    postervideo.addEventListener('click', function(){
        if (!this.getAttribute('loaded')) {
          const content = document.createElement('div');
          content.appendChild(this.nextElementSibling.content.firstElementChild.cloneNode(true));
          this.parentElement.setAttribute('loaded', true);
          this.parentElement.appendChild(content.querySelector('video, model-viewer, iframe')).focus();
        }
	});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["lopez-product-v4"] && !Shopify.designMode) return;
  try {
    
document.querySelectorAll('[data-lopez-v4]').forEach(root=>{if(root.dataset.lopezReady==='true')return;root.dataset.lopezReady='true';root.querySelectorAll('[data-lopez-thumb]').forEach(button=>button.addEventListener('click',()=>{root.querySelectorAll('[data-lopez-thumb]').forEach(item=>item.setAttribute('aria-pressed','false'));button.setAttribute('aria-pressed','true');const image=button.querySelector('img');const main=root.querySelector('.lopez-v4-main-image');main.removeAttribute('srcset');main.src=button.dataset.largeSrc;main.alt=image.alt;const room=button.dataset.room==='true';root.querySelector('[data-lopez-photo-count]').textContent=button.dataset.photo.padStart(2,'0')+' / 04';root.querySelector('[data-lopez-photo-tag]').textContent=room?root.dataset.roomTag:root.dataset.productTag;root.querySelector('[data-lopez-photo-caption]').textContent=room?root.dataset.roomCaption:root.dataset.productCaption;}));root.querySelectorAll('[data-lopez-quantity]').forEach(button=>button.addEventListener('click',()=>{const input=root.querySelector('input[name="quantity"]');const step=Number(input.step)||1;const min=Number(input.min)||1;const next=Math.max(min,(Number(input.value)||min)+Number(button.dataset.lopezQuantity)*step);input.value=input.max?Math.min(Number(input.max),next):next;input.dispatchEvent(new Event('change',{bubbles:true}));}));const variants=root.querySelector('[data-lopez-variants]');if(variants)variants.addEventListener('change',()=>{const option=variants.selectedOptions[0];const available=option.dataset.available==='true';root.querySelector('[data-lopez-price]').textContent=option.dataset.price;root.querySelector('[data-lopez-stock]').textContent=available?root.dataset.availableLabel:root.dataset.unavailableLabel;const submit=root.querySelector('[data-lopez-submit]');submit.disabled=!available;submit.textContent=available?root.dataset.cartLabel:root.dataset.unavailableLabel;});});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["top-bar"]) return;
  try {
    
    jQuery(document).ready(function ($) {
        $('.btn-close').on('click', function(){
        $(this).parents('.parent-close').slideUp();
        })
    });

  } catch(e) { console.error(e); }
})();
})();
